:host {
  display: block;
}

h2 {
  font-family:'Lato';
  font-weight:'regular';
  line-height:120%;
  font-size:63px;
  letter-spacing:1.5;
  text-decoration:none;
}
